import { accountDb } from './firebase';
import { collection, query, where, getDocs, doc, getDoc } from 'firebase/firestore';

export const authService = {
  /**
   * Attempts to log in by checking if a document exists in 'sync_data'
   * with the matching username and password.
   */
  async login(username: string, pass: string): Promise<boolean> {
    if (!accountDb) return false;
    
    try {
      const usersRef = collection(accountDb, 'sync_data');
      // Query for matching username and password fields
      const q = query(
        usersRef, 
        where('username', '==', username),
        where('password', '==', pass)
      );
      
      const snapshot = await getDocs(q);
      return !snapshot.empty;
    } catch (e) {
      console.error("Login error:", e);
      throw e;
    }
  },

  /**
   * Validates a handover token from the URL against the 'handover_tokens' collection.
   * Also verifies that the userId exists in 'sync_data'.
   * Returns the userId if valid and exists, null otherwise.
   */
  async validateHandoverToken(token: string): Promise<string | null> {
    if (!accountDb) return null;

    try {
      // 1. Check Token
      const docRef = doc(accountDb, 'handover_tokens', token);
      const docSnap = await getDoc(docRef);

      if (!docSnap.exists()) {
        console.warn("Token document not found");
        return null;
      }

      const data = docSnap.data();
      const targetApp = data.targetApp;
      const userId = data.userId;

      // Verify targetApp matches
      if (targetApp !== 'ledger') {
        console.warn("Token targetApp mismatch:", targetApp);
        return null;
      }
      
      if (!userId) {
        console.warn("Token has no userId");
        return null;
      }

      // 2. Check User Existence in sync_data
      // We assume userId in handover_tokens corresponds to 'username' in sync_data
      const usersRef = collection(accountDb, 'sync_data');
      const q = query(usersRef, where('username', '==', userId));
      const userSnap = await getDocs(q);

      if (!userSnap.empty) {
        return userId as string;
      } else {
        console.warn(`User '${userId}' specified in token not found in sync_data`);
        return null;
      }

    } catch (e) {
      console.error("Token validation error:", e);
      return null;
    }
  }
};